import { render, staticRenderFns } from "./FeaturedProject.vue?vue&type=template&id=feda498e&"
import script from "./FeaturedProject.vue?vue&type=script&lang=js&"
export * from "./FeaturedProject.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports